// Message-list shaping for the conversation column: day dividers and
// consecutive-sender grouping so the bubble UI doesn't repeat the sender
// label on every line.
import { ChatMessage } from './types';

export type ConversationItem =
  | { kind: 'day'; key: string; label: string }
  | { kind: 'group'; key: string; sender_type: ChatMessage['sender_type']; admin_name?: string; messages: ChatMessage[] };

const isSameDay = (a: string, b: string) => new Date(a).toDateString() === new Date(b).toDateString();

export const dayLabel = (iso: string): string => {
  const date = new Date(iso);
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);
  if (isSameDay(iso, today.toISOString())) return 'Today';
  if (isSameDay(iso, yesterday.toISOString())) return 'Yesterday';
  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: date.getFullYear() === today.getFullYear() ? undefined : 'numeric',
  });
};

export const clockTime = (iso: string): string =>
  new Date(iso).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });

export function groupMessages(messages: ChatMessage[]): ConversationItem[] {
  const items: ConversationItem[] = [];
  let lastDay: string | null = null;
  let currentGroup: Extract<ConversationItem, { kind: 'group' }> | null = null;

  for (const message of messages) {
    if (!lastDay || !isSameDay(lastDay, message.created_at)) {
      items.push({ kind: 'day', key: `day-${message.id}`, label: dayLabel(message.created_at) });
      lastDay = message.created_at;
      currentGroup = null;
    }

    const continuesGroup =
      currentGroup && currentGroup.sender_type === message.sender_type && currentGroup.admin_name === message.admin_name;

    if (continuesGroup && currentGroup) {
      currentGroup.messages.push(message);
    } else {
      currentGroup = { kind: 'group', key: `g-${message.id}`, sender_type: message.sender_type, admin_name: message.admin_name, messages: [message] };
      items.push(currentGroup);
    }
  }

  return items;
}
